import Component from 'components/ThankYou';
import {connect} from 'react-redux';
import withRouter from 'utils/withRouter';
import {currentId} from 'selectors/worksSelectors';

const mapStateToProps = (state, ownProps) => ({
	artists: state.artists,
	id: currentId(state)
})

const mapDispatchToProps = (dispatch, ownProps) => ({
	navigateTo: (location) => {
		if (ownProps.navigate) {
			ownProps.navigate(location);
		}
	}
})

const Container = withRouter(connect(
	mapStateToProps,
	mapDispatchToProps
)(Component));
export default Container;